<template>
  <fragment>
    <div class="emd-card-grid__column">
      <p class="emd-text _color_subtle _type_caption eu-mb_1">
        {{ createdAt.title }}
      </p>
      <p class="emd-card-grid__line">
        {{ createdAt.date | dateFormat('dateAndHour') }}
      </p>
    </div>
    <div class="emd-card-grid__column">
      <p class="emd-text _color_subtle _type_caption eu-mb_1">
        {{ updatedAt.title }}
      </p>
      <p class="emd-card-grid__line">
        {{ updatedAt.date | dateFormat('dateAndHour') }}
      </p>
    </div>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

export default {
  name: 'ChargesPaymentMethodDetailAt',

  components: {
    Fragment
  },

  props: {
    updatedAt: { required: true },
    createdAt: { required: true }
  }
}
</script>
